const messages = {
  title: 'Internal Error',
  description: 'Data for this page cannot be loaded properly.',
  backHomeButton: 'Back To Dashboard'
}

export default {
  messages
}
